import { axiosWithTokenForBlob } from "./axiosService";

export const downloadPatchnote = async () => {
    try {
        const response = await axiosWithTokenForBlob().get(`api/patchnote`, { responseType: 'blob' })
        return response
    } catch (err) {
        throw err;
    }
}